import React, { useRef, useState, useEffect } from 'react';
import { FaStar, FaGoogle, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { getReviews } from '../services/api';

const ReviewCard = ({ review }) => (
  <div className="min-w-[320px] max-w-[360px] bg-white rounded-2xl p-6 shadow-md flex-shrink-0 border border-gray-100 hover:shadow-lg transition-shadow">
    <div className="flex items-center space-x-3 mb-4">
      <div className="w-12 h-12 bg-gradient-to-br from-red-400 to-red-600 rounded-full flex items-center justify-center text-white font-bold">
        {review.avatar}
      </div>
      <div>
        <h4 className="font-semibold text-gray-900">{review.name}</h4>
        <p className="text-xs text-gray-400">{review.time}</p>
      </div>
      <FaGoogle className="text-blue-500 ml-auto text-lg" />
    </div>
    <div className="flex items-center space-x-1 mb-3">
      {Array.from({ length: review.rating }, (_, i) => (
        <FaStar key={i} className="text-yellow-400 text-sm" />
      ))}
    </div>
    <p className="text-sm text-gray-600 leading-relaxed line-clamp-4">
      {review.text}
    </p>
    <button className="text-red-500 text-xs font-medium mt-2 hover:underline">
      Read more
    </button>
  </div>
);

const Reviews = () => {
  const scrollRef = useRef(null);
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    getReviews().then(data => setReviews(data || []));
  }, []);


  const scroll = (dir) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: dir * 360, behavior: 'smooth' });
    }
  };

  return (
    <section id="reviews" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10">
          <span className="text-red-500 text-sm font-semibold uppercase tracking-wider">REVIEWS</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-2">
            Hear from Our Happy Home Buyers
          </h2>
          <p className="text-gray-500 mt-2">Real Reviews, Real Experiences, Real Trust</p>

          <div className="flex items-center space-x-3 mt-4">
            <span className="text-4xl font-bold text-gray-900">4.8</span>
            <div>
              <div className="flex items-center space-x-1">
                {Array.from({ length: 5 }, (_, i) => (
                  <FaStar key={i} className="text-yellow-400" />
                ))}
              </div>
              <p className="text-sm text-gray-500 mt-1">
                2,259 reviews on <span className="text-blue-500 font-medium">Google</span>
              </p>
            </div>
          </div>
        </div>

        <div className="relative">
          <button
            onClick={() => scroll(-1)}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-5 z-10 w-10 h-10 rounded-full bg-white shadow-lg border border-gray-100 flex items-center justify-center hover:bg-red-50 transition"
          >
            <FaChevronLeft className="text-gray-600" />
          </button>

          <div
            ref={scrollRef}
            className="flex space-x-5 overflow-x-auto pb-4 scroll-container"
          >
          {reviews.map((review, idx) => (
            <ReviewCard key={idx} review={review} />
          ))}
          </div>

          <button
            onClick={() => scroll(1)}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-5 z-10 w-10 h-10 rounded-full bg-white shadow-lg border border-gray-100 flex items-center justify-center hover:bg-red-50 transition"
          >
            <FaChevronRight className="text-gray-600" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
